import { CampaignsEmptyState, NoResult } from 'ui/illustrations';
import { Link } from 'ui/links';
import { PlaceholderState } from 'ui/indexPages/PlaceholderState';
import styled from 'styled-components';

const StyledPlaceholderState = styled(PlaceholderState)`
text-align: center;
`;

const displayNoResultsContent = {
  mainText: 'There aren’t any sent messages for this time range',
  description: 'Try searching a different time range or selecting a different campaign.',
};

export const NoResults = () => (
  <StyledPlaceholderState
    Illustration={NoResult}
    id="sent-message-logs-index-no-results"
    data-test="sent-message-logs-index-no-results"
    title={displayNoResultsContent.mainText}
  >
    {displayNoResultsContent.description}
  </StyledPlaceholderState>
);

const displayNoCampaignsContent = {
  mainText: 'No campaigns yet',
  description: 'Message and engage your contacts across various channels.',
  linkDescription: 'Learn more by visiting our',
  linkBtn: 'Knowledge Center',
  linkUrl: 'https://support.iterable.com/',
};

export const NoCampaigns = () => (
  <StyledPlaceholderState
    Illustration={CampaignsEmptyState}
    id="sent-message-logs-index-no-campaigns"
    data-test="sent-message-logs-index-no-campaigns"
    title={displayNoCampaignsContent.mainText}
  >
    <>
      {displayNoCampaignsContent.description}
      <br />
      {displayNoCampaignsContent.linkDescription}{' '}
      <Link size="body1" href={displayNoCampaignsContent.linkUrl}>
        {displayNoCampaignsContent.linkBtn}
      </Link>
      .
    </>
  </StyledPlaceholderState>
);
